import api from '@/libs/axios'

export default {
  getSectors: () => api.get('/system/sector/'),
  getSectorById: id => api.get(`/system/sector/${id}`),
}
